import React, { Component, Fragment } from "react";
import {
  getVideoPlayer,
  getURLVideo,
  isAmazon
} from "../../utils/helpers/video";
import { getKey } from "../../utils/helpers";
import VideoPlayer from "../VideoPlayer";
import "./AtVideo.scss";

class Video extends Component {
  render() {
    const {
      video,
      title,
      streaming_provider,
      d: duration,
      nextVideoSlug,
      introTime,
      creditTime
    } = this.props;

    if (isAmazon(streaming_provider)) {
      return (
        <VideoPlayer
          url={getURLVideo(this.props)}
          title={title || ""}
          assetId={video ? video.assetid : ""}
          poster={getKey(video, "thumbnail.path", "")}
          isLive={false}
          duration={duration || 0}
          nextVideoSlug={nextVideoSlug}
          introTime={introTime}
          creditTime={creditTime}
        />
      );
    }

    const videoPlayer = getVideoPlayer(this.props);

    return (
      <Fragment>
        <div
          className={`videoWrapper`}
          dangerouslySetInnerHTML={{ __html: videoPlayer }}
        />
      </Fragment>
    );
  }
}

export default Video;
